import {
  IconoLogistica, IconoConversaciones, IconoAgendamiento, IconoCalendario, IconoConfirmar, IconoRecalculo, IconoGE,
  IconoCampana, IconoCampanaAlerta,
  IconoLogisticaSolido, IconoConversacionesSolido,
  IconoAgendamientoSolido, IconoCalendarioSolido, IconoConfirmarSolido, IconoRecalculoSolido, IconoGESolido,
} from './iconos'

export interface Destino {
  ruta: string
  etiqueta: string
  /**
   * El rotulo de la barra inferior de movil.
   *
   * La barra movil solo muestra los destinos marcados `movilFijo`; el resto
   * vive detras del boton "Mas". La barra lateral de escritorio usa `etiqueta`.
   */
  etiquetaMovil: string
  /** Si aparece fijo en la barra inferior de movil (los mas usados). */
  movilFijo?: boolean
  Icono: React.ComponentType<{ className?: string }>
  IconoActivo: React.ComponentType<{ className?: string }>
}

/** Un grupo del menu lateral (seccion colapsable). */
export interface GrupoNav {
  titulo: string
  /** Si arranca colapsado (sistema, que se toca poco). */
  colapsadoPorDefecto?: boolean
  destinos: Destino[]
}

/**
 * El menu agrupado en tres secciones por lo que hace cada una. Se consolidó de
 * diez destinos a seis: "Gestión" fusiona Confirmar+Avisos+Incidencias (listas
 * de casos que requieren acción humana) y "Sistema" fusiona Auditoría+Recálculo
 * (lecturas de qué hizo el sistema solo). Cada subpantalla sigue siendo
 * direccionable por ?tab=, así que los enlaces viejos no se rompen.
 */
export const GRUPOS: GrupoNav[] = [
  {
    titulo: 'Operación diaria',
    destinos: [
      { ruta: '/logistica', etiqueta: 'Logística', etiquetaMovil: 'Logística', movilFijo: true, Icono: IconoLogistica, IconoActivo: IconoLogisticaSolido },
      { ruta: '/agendamiento', etiqueta: 'Agendamiento', etiquetaMovil: 'Agenda', movilFijo: true, Icono: IconoAgendamiento, IconoActivo: IconoAgendamientoSolido },
      { ruta: '/calendario', etiqueta: 'Calendario', etiquetaMovil: 'Calend.', Icono: IconoCalendario, IconoActivo: IconoCalendarioSolido },
    ],
  },
  {
    titulo: 'Clientes y Leads',
    destinos: [
      { ruta: '/conversaciones', etiqueta: 'Conversaciones', etiquetaMovil: 'Mensajes', movilFijo: true, Icono: IconoConversaciones, IconoActivo: IconoConversacionesSolido },
      { ruta: '/gestion', etiqueta: 'Gestión', etiquetaMovil: 'Gestión', movilFijo: true, Icono: IconoConfirmar, IconoActivo: IconoConfirmarSolido },
      { ruta: '/alertas', etiqueta: 'Alertas', etiquetaMovil: 'Alertas', Icono: IconoCampana, IconoActivo: IconoCampanaAlerta },
      { ruta: '/grandes-empresas', etiqueta: 'Grandes Empresas', etiquetaMovil: 'GE', Icono: IconoGE, IconoActivo: IconoGESolido },
    ],
  },
  {
    titulo: 'Sistema',
    colapsadoPorDefecto: true,
    destinos: [
      { ruta: '/sistema', etiqueta: 'Sistema', etiquetaMovil: 'Sistema', Icono: IconoRecalculo, IconoActivo: IconoRecalculoSolido },
    ],
  },
]

/** Lista plana de todos los destinos (para el móvil y para contar). */
export const DESTINOS: Destino[] = GRUPOS.flatMap((g) => g.destinos)
